<script setup>
import { ref } from "vue";
import { EyeSlashIcon, EyeIcon } from "@heroicons/vue/24/solid";
import { setPassword } from "@/services/auth";

import { useRoute } from "vue-router";

const router = useRoute();

const passwordVisible = ref(false);
const confirmPasswordVisible = ref(false);

const password = ref("");
const confirmPassword = ref("");
const errorMessage = ref("");

const handleSubmit = () => {
  errorMessage.value = "";

  if (password.value.length < 8 || password.value.includes(" ")) {
    errorMessage.value =
      "La contraseña debe tener al menos 8 caracteres y no contener espacios.";
    return;
  }

  if (password.value !== confirmPassword.value) {
    errorMessage.value =
      "Las contraseñas no coinciden. Por favor revisa e intenta nuevamente.";
    return;
  }
  console.log("Contraseña válida");
  const structureObject = {
    token: router.params.token,
    password: password.value,
  };

  setPassword(structureObject)
    .then((response) => {
      console.log("Contraseña establecida correctamente:", response);
      router.push("/login");
    })
    .catch((error) => {
      console.error("Error al establecer la contraseña:", error);
      errorMessage.value =
        error.response?.data?.message ||
        "Ocurrió un error al establecer la contraseña. Por favor, inténtalo de nuevo.";
    });
};
</script>
<template>
  <article class="global-container register">
    <div class="register-card">
      <div class="card-body">
        <h5 class="register-title">Golden Contactability</h5>
        <h6 class="register-pre-title">
          Por favor, crea tu contraseña para poder ingresar a la plataforma.
        </h6>

        <form @submit.prevent="handleSubmit">
          <div class="mb-3">
            <label for="password" class="form-label">Nueva Contraseña</label>
            <div
              class="register-input form-control"
              style="display: flex; padding: 10px 20px 10px 20px"
            >
              <input
                :type="passwordVisible ? 'text' : 'password'"
                class="input-in"
                id="password"
                v-model="password"
              />
              <button
                tabindex="button"
                @click="passwordVisible = !passwordVisible"
                style="background-color: transparent; border: none"
              >
                <component
                  :is="passwordVisible ? EyeIcon : EyeSlashIcon"
                  class="text-blue-500"
                  style="width: 20px; height: 20px"
                />
              </button>
            </div>
            <span class="note-text"
              >* Crea una contraseña de 8 caracteres, sin espacios</span
            >
          </div>
          <div class="mb-3">
            <label for="confirmPassword" class="form-label"
              >Confirma la Contraseña</label
            >
            <div
              class="register-input form-control"
              style="display: flex; padding: 10px 20px 10px 20px"
            >
              <input
                :type="confirmPasswordVisible ? 'text' : 'password'"
                class="input-in"
                id="password"
                v-model="confirmPassword"
              />
              <button
                tabindex="button"
                @click="confirmPasswordVisible = !confirmPasswordVisible"
                style="background-color: transparent; border: none"
              >
                <component
                  :is="confirmPasswordVisible ? EyeIcon : EyeSlashIcon"
                  class="text-blue-500"
                  style="width: 20px; height: 20px"
                />
              </button>
            </div>
          </div>

          <div v-if="errorMessage" class="error-message text-danger">
            {{ errorMessage }}
          </div>

          <div class="d-flex justify-content-center">
            <button type="submit" class="btn register-button">
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  </article>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.error-message {
  text-align: center;
  color: $error2-color;
  margin: 5px 0;
}
.note-text {
  color: $six-color;
  font-size: 0.7em;
}
.input-in {
  border: none;
  width: 100%;
  &:focus,
  &:focus-within {
    outline: none;
    box-shadow: none;
  }
}
</style>
